import React from 'react'
import { Button, Card } from 'react-bootstrap'
import './underwork.css'

export default function Underwork({message}) {


return ( 


  <div className='bg-under-work container'>

<div class="loading"> 
       <p>   {message}     <span class="dots">...</span></p>
       {/* <Button onClick={() => updateSupervisor()} > Upload </Button> */}
       </div>

</div>
)


}